import rpcClient from './RpcClient';
import { upsertBufferRpc, getBuffersForObjectIdRpc, getGridLayoutBufferByIdRpc, getBufferForDndAreaNameRpc, GridLayoutTypename, ReusableBlockContentBaseTypename } from '../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutBuffersRpc';
export function fetchGridLayoutBufferById(id) {
  return rpcClient.call(getGridLayoutBufferByIdRpc, {
    request: {
      id
    }
  });
}
export function upsertGridLayoutBuffer(contentId, gridLayout) {
  return rpcClient.call(upsertBufferRpc, {
    request: {
      objectId: contentId,
      gridLayout
    }
  });
}
export function fetchGridLayoutBuffersForContentId(contentId) {
  return rpcClient.call(getBuffersForObjectIdRpc, {
    request: {
      objectId: contentId
    }
  });
}
export function fetchGridLayoutBufferByDndAreaName(contentId, dndAreaName) {
  return rpcClient.call(getBufferForDndAreaNameRpc, {
    request: {
      objectId: contentId,
      dndAreaName
    }
  });
}
export function isGridLayoutWithMeta(metaObject) {
  var _metaObject$gridLayou;
  return (metaObject === null || metaObject === void 0 || (_metaObject$gridLayou = metaObject.gridLayout) === null || _metaObject$gridLayou === void 0 ? void 0 : _metaObject$gridLayou.__typename) === GridLayoutTypename;
}
export function isReusableBlockWithMeta(metaObject) {
  var _metaObject$gridLayou2;
  return (metaObject === null || metaObject === void 0 || (_metaObject$gridLayou2 = metaObject.gridLayout) === null || _metaObject$gridLayou2 === void 0 ? void 0 : _metaObject$gridLayou2.__typename) === ReusableBlockContentBaseTypename;
}